import SEO from "@/components/SEO";
import PageHero from "@/components/PageHero";
import Reveal from "@/components/Reveal";
import { VisaCard } from "@/components/Cards";
import { useContent } from "@/lib/content";
import { IMG, VISA_PROCESS } from "@/lib/site";

export default function VisaListing() {
  const { visas, loading } = useContent();

  return (
    <div data-testid="visa-listing-page">
      <SEO title="Visa Assistance" description="Expert visa assistance for Indian travellers — Singapore, Dubai/UAE, Schengen, UK, USA, Canada, Australia, Japan, Thailand, Vietnam, Malaysia and Sri Lanka visas." />
      <PageHero image={IMG.plane2} overline="Documentation, Done Right" title="Visa Assistance"
                description="Expert visa documentation, appointment booking and application tracking for 12+ popular destinations — with honest guidance, never false promises." />
      <section className="py-14 lg:py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <Reveal>
            <h2 className="font-heading text-2xl sm:text-3xl font-bold tracking-tight text-slate-900">How It Works</h2>
          </Reveal>
          <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
            {VISA_PROCESS.map((s, i) => (
              <Reveal key={s.step} delay={i * 0.06}>
                <div className="rounded-2xl bg-white border border-slate-200/80 p-6 shadow-sm h-full" data-testid={`visa-process-${s.step}`}>
                  <span className="font-display italic text-3xl text-gold">{s.step}</span>
                  <h3 className="mt-3 font-heading font-bold text-slate-900">{s.title}</h3>
                  <p className="mt-2 text-sm text-slate-500 leading-relaxed">{s.description}</p>
                </div>
              </Reveal>
            ))}
          </div>

          <Reveal className="mt-16">
            <h2 className="font-heading text-2xl sm:text-3xl font-bold tracking-tight text-slate-900">Visas We Assist With</h2>
          </Reveal>
          {loading ? (
            <p className="mt-10 text-slate-400">Loading visa guides...</p>
          ) : (
            <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
              {visas.map((v, i) => <Reveal key={v.slug} delay={(i % 4) * 0.05}><VisaCard visa={v} /></Reveal>)}
            </div>
          )}
          <p className="mt-8 text-xs text-slate-400 max-w-3xl" data-testid="visa-disclaimer">
            Disclaimer: Visa approval is solely at the discretion of the respective embassy, consulate or immigration authority. D Travel Link provides documentation guidance and application assistance only and does not guarantee visa approval.
          </p>
        </div>
      </section>
    </div>
  );
}
